import { ReactNode } from "react";

export interface CommonModel {
  [key: string]: any
}

export interface ColumnModel {
  key: string;
  title: string | ReactNode;
  dataIndex: string | string[];
  show?: boolean;
  ellipsis?: boolean | ColumnEllipsisModel;
}

export interface ColumnEllipsisModel {
  showTitle?: boolean
}

export interface BasicStateForListModel<T = any> {
  loading: boolean;
  columns: Array<ColumnModel>;
  data: Array<T>;
  pageSize: number;
  pageIndex: number;
  totalCount: number;
}

export enum RoleTypes {
  'SuperAdmin' = 'SuperAdmin',
  'CoAdmin' = 'CoAdmin',
  'Contributor' = 'Contributor',
  'Owner' = 'Owner',
  'ResourceAccess' = 'ResourceAccess'
}

export const DeviceTypes:any = {
  Phone: '手机',
  PC: '电脑',
  Pad: '平板'
}

export enum DevicePlatformTypes {
  'IOS' = 'IOS',
  'Android' = 'Android',
  'macOS' = 'macOS',
  'Windows' = 'Windows'
}

export const DeviceOperationTypes:any = {
  Lock: '锁定设备',
  Install: '安装应用',
  UnInstall:'卸载应用',
  Location: '获取定位',
  Sync: '同步设备',
  Reset: '还原设备',
}